import { DateInput } from '@safetyhub/ui';
import type { SiteCreationConstruction } from '../../hooks/useSiteCreationState';

export interface SiteFormStepConstructionProps {
  value: SiteCreationConstruction;
  onChange: (next: SiteCreationConstruction) => void;
}

export function SiteFormStepConstruction({
  value,
  onChange,
}: SiteFormStepConstructionProps) {
  const handleChange = <K extends keyof SiteCreationConstruction>(
    field: K,
    next: SiteCreationConstruction[K],
  ) => {
    onChange({ ...value, [field]: next });
  };

  const inputClass =
    'block w-full min-w-0 px-2 py-1.5 border border-ink-300 rounded-control text-sm focus:ring-brand-500 focus:border-brand-500';
  const labelClass = 'block text-xs font-medium text-ink-700';

  return (
    <div className="space-y-4 min-w-0">
      <p className="text-xs text-ink-500">
        건설업 현장에만 해당하는 정보입니다. 건너뛰거나 나중에 사업장 상세에서
        입력할 수 있습니다.
      </p>

      <div>
        <label htmlFor="step-construction-cost" className={labelClass}>
          공사금액 (원)
        </label>
        <input
          type="number"
          id="step-construction-cost"
          value={value.constructionCost}
          onChange={(e) => handleChange('constructionCost', e.target.value)}
          min="0"
          className={inputClass}
          placeholder="예: 500000000"
        />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label htmlFor="step-construction-start" className={labelClass}>
            착공일
          </label>
          <DateInput
            label="착공일"
            id="step-construction-start"
            size="sm"
            className="w-full"
            value={value.constructionStart}
            onChange={(next) => handleChange('constructionStart', next)}
          />
        </div>
        <div>
          <label htmlFor="step-construction-end" className={labelClass}>
            준공일
          </label>
          <DateInput
            label="준공일"
            id="step-construction-end"
            size="sm"
            className="w-full"
            value={value.constructionEnd}
            onChange={(next) => handleChange('constructionEnd', next)}
          />
        </div>
      </div>

      <div>
        <label htmlFor="step-management-number" className={labelClass}>
          사업장관리번호
        </label>
        <input
          type="text"
          id="step-management-number"
          value={value.managementNumber}
          onChange={(e) => handleChange('managementNumber', e.target.value)}
          className={inputClass}
          placeholder="예: 123-45-67890"
        />
      </div>

      <div>
        <label htmlFor="step-license-number" className={labelClass}>
          면허번호
        </label>
        <input
          type="text"
          id="step-license-number"
          value={value.licenseNumber}
          onChange={(e) => handleChange('licenseNumber', e.target.value)}
          className={inputClass}
          placeholder="예: 종합 제1234호"
        />
      </div>

      <div>
        <label htmlFor="step-progress-rate" className={labelClass}>
          공정률 (%)
        </label>
        <input
          type="number"
          id="step-progress-rate"
          value={value.progressRate}
          onChange={(e) => handleChange('progressRate', e.target.value)}
          min="0"
          max="100"
          className={inputClass}
          placeholder="예: 45"
        />
      </div>

      <div>
        <label htmlFor="step-client-name" className={labelClass}>
          발주자명
        </label>
        <input
          type="text"
          id="step-client-name"
          value={value.clientName}
          onChange={(e) => handleChange('clientName', e.target.value)}
          className={inputClass}
          placeholder="예: 한국도로공사"
        />
      </div>

      <div>
        <label htmlFor="step-client-contact" className={labelClass}>
          발주자 연락처
        </label>
        <input
          type="text"
          id="step-client-contact"
          value={value.clientContact}
          onChange={(e) => handleChange('clientContact', e.target.value)}
          className={inputClass}
          placeholder="예: 02-1234-5678"
        />
      </div>
    </div>
  );
}
